module.exports = "<div class='menu'>\n  <div>\n    <app-tag-patent-menu *ngFor='let c of countries'\n        tp='country'\n        [label]='c'\n        [value]='c'></app-tag-patent-menu>\n  </div>\n\n  <div>\n    <app-tag-patent-menu *ngFor='let s of stages'\n        tp='stage'\n        [label]='s'\n        [value]='s'></app-tag-patent-menu>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/patent-menu/patent-menu.component.html
// module id = 433
// module chunks = 0